export default __webpack_public_path__ + "static/media/musical.91941536.png";